import React, {useState} from 'react';

import appConfig from '../../config/appConfig';
import UWM_COMMAND_TYPES from '../../consts/uwm/uwmCommendTypes';
import UWM_EVENT_TYPES from '../../consts/uwm/uwmEventTypes';
import useEventListener from '../../hooks/useEventListener';
import {useUWMUnavailabilityHandler} from '../../hooks/useUWMUnavailabilityHandler';
import {amplitudeScreensTracking} from '../../services/amplitude';
import log from '../../services/logger/log';
import helpers from '../../utils/helpers';
import {twx} from '../../utils/tailwindUtils';

const UwmModule = (props) => {
    const {src, onModuleLoaded, onBackButtonClick, onCompleteCleaningGuide, onSupportButtonClick} = props;
    const [moduleHeight, setModuleHeight] = useState();
    const [isModuleDataLoaded, setIsModuleDataLoaded] = useState(false);
    const [isModuleDataLoadedError, setIsModuleDataLoadedError] = useState(false);
    const {hasFullHeightOnMobile, hasFullHeightOnDesktop} = getHeightFlags();

    const refreshAction = () => {
        setIsModuleDataLoaded(true);
        setIsModuleDataLoadedError(false);
        onModuleLoaded();
    };

    useUWMUnavailabilityHandler({isVisible: !isModuleDataLoaded, isError: isModuleDataLoadedError, refreshAction});

    useEventListener(
        'message',
        (event) => {
            const {detail} = event?.data || {};

            if (detail?.command === UWM_COMMAND_TYPES.UWM_EVENT) {
                log.debug(`UwmModule: detail: ${JSON.stringify(detail)}`);

                switch (detail.payload?.type) {
                    case UWM_EVENT_TYPES.UWM_MODULE_LOADED: {
                        onModuleLoaded();
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_DATA_RECEIVED_SUCCESS: {
                        setIsModuleDataLoaded(true);
                        amplitudeScreensTracking.trackTipsAndTutorialsScreen();
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_RESIZE: {
                        setModuleHeight(detail.payload.height);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_BACK_BUTTON_CLICK: {
                        helpers.runFunction(onBackButtonClick);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_INITIALIZATION_ERROR: {
                        log.info(`UwmModule: UWM_MODULE_INITIALIZATION_ERROR: ${JSON.stringify(detail)}`);
                        setIsModuleDataLoadedError(true);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_COMPLETE_GUIDE: {
                        helpers.runFunction(onBackButtonClick);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_COMPLETE_CLEANING_GUIDE: {
                        helpers.runFunction(onCompleteCleaningGuide);
                        break;
                    }
                    case UWM_EVENT_TYPES.UWM_MODULE_SUPPORT_BTN_CLICK: {
                        helpers.runFunction(onSupportButtonClick);
                        break;
                    }
                    default:
                        break;
                }
            }
        },
        window
    );

    return (
        <iframe
            title='uwmIframe'
            id='uwmIframe'
            src={src}
            className={twx(
                'w-full',
                hasFullHeightOnMobile ? 'min-h-screen' : 'min-h-[568px]',
                hasFullHeightOnDesktop ? 'md:min-h-screen' : 'md:min-h-[568px]'
            )}
            height={moduleHeight}
        />
    );
};

const getHeightFlags = () => {
    const isStandalone = process.env.REACT_APP_IS_BUILD_REF !== 'true';

    const hasFullHeightOnMobile = isStandalone || appConfig.getIsMonolith();
    const hasFullHeightOnDesktop = isStandalone;

    return {hasFullHeightOnMobile, hasFullHeightOnDesktop};
};

export default UwmModule;
